export default function FooterUA() {
  return (
    <footer>
      <div className="max-w-7xl mx-auto px-6">
        <div className="pt-10 lg:pt-18">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-4/12">
              <div>
                <a href="/ua" className="mb-10 lg:mb-20 inline-block">
                  <img src="/images/logo/logo-square.webp" alt="CV Box Logo" className="h-25 w-auto object-contain" width={200} height={200} />
                </a>
                <p className="lg:pr-10 text-gray-500 text-base">
                  Побудуй професійний профіль, відстежуй вакансії та генеруй персоналізовані матеріали для заявок за допомогою AI. Звіти сумісності, оптимізовані CV, cover letters та кар'єрний коучинг з Job Agent. Довіряють 1,200+ шукачів роботи по всьому світу.
                </p>
              </div>
            </div>
            <div className="lg:w-6/12 lg:ml-auto">
              <div className="grid grid-cols-2 gap-5 sm:gap-10 sm:grid-cols-3">
                <div>
                  <h3 className="text-lg text-gray-800 font-medium mb-6">
                    Продукт
                  </h3>
                  <nav className="space-y-5">
                    <a
                      href="/ua"
                      className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                    >
                      Головна
                    </a>
                    <a
                      href="/ua#features"
                      className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                    >
                      Можливості
                    </a>
                    <a
                      href="/ua#pricing"
                      className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                    >
                      Тарифи
                    </a>
                  </nav>
                </div>
                <div>
                  <h3 className="text-lg text-gray-800 font-medium mb-6">
                    Компанія
                  </h3>
                  <nav className="space-y-5">
                    <a
                      href="/ua/contact"
                      className="text-gray-700 block text-base hover:text-indigo-500 transition-colors duration-300 ease-in-out"
                    >
                      Контакти
                    </a>
                    <a href="/privacy" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                      Політика конфіденційності
                    </a>
                    <a href="/cookie" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                      Політика cookies
                    </a>
                    <a href="/terms" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                      Умови використання
                    </a>
                    <a href="/company" className="text-gray-700 block text-base hover:text-indigo-500 transition-colors">
                      Реквізити компанії
                    </a>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-between flex-col sm:flex-row gap-5 items-center pb-10 pt-10 lg:pt-20">
          <p className="text-base text-gray-500">
            © 2025 - {new Date().getFullYear()} CV Box. Всі права захищені.
          </p>
          <div className="flex gap-3 items-center text-gray-700">
            Нагору
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="size-7 rounded-full text-white bg-indigo-500 inline-flex items-center justify-center hover:bg-indigo-600 transition duration-300 ease-in-out cursor-pointer"
              aria-label="Нагору"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10.2053 2.79053C10.2486 2.79053 10.291 2.7952 10.3323 2.80225C10.481 2.82707 10.6238 2.89561 10.7385 3.01025L15.7385 8.00635C16.0315 8.29911 16.0312 8.7739 15.7385 9.06689C15.4457 9.3598 14.971 9.36059 14.678 9.06787L10.9553 5.34619L10.9553 16.8745C10.9553 17.2887 10.6195 17.6245 10.2053 17.6245C9.7912 17.6244 9.45538 17.2886 9.45532 16.8745L9.45532 5.35205L5.73853 9.06787C5.44554 9.36055 4.97074 9.35982 4.67798 9.06689C4.38532 8.77392 4.3851 8.29912 4.67798 8.00635L9.6604 3.02686C9.67433 3.01208 9.68927 2.99847 9.70435 2.98486C9.72164 2.96917 9.73972 2.95471 9.75806 2.94092C9.84661 2.87472 9.94909 2.82606 10.0618 2.8042C10.064 2.80375 10.0663 2.80365 10.0686 2.80322C10.113 2.79504 10.1586 2.79054 10.2053 2.79053Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
